import { type LucideIcon } from "lucide-react";

/** Each size's square, in px. */
const SIZES = { xs: 12, sm: 14, md: 16, lg: 20, xl: 24 } as const;

/** One of lucide's icons, at one of the app's sizes, in its own lines. */
export function Icon({
  ReactIcon,
  size = "md",
  style = {},
  ...props
}: {
  ReactIcon: LucideIcon;
  size?: keyof typeof SIZES;
  style?: React.CSSProperties;
  [key: string]: any;
}) {
  if (!ReactIcon) {
    return null;
  }
  return <ReactIcon size={SIZES[size]} style={style} {...props} />;
}
